
const proBadge = "<span>(Pro)</span>";
let appendProBadge = setInterval(function() {
    if (typeof $ !== 'undefined') { // wait until jQuery has been loaded
        // ,data-variant-id]
        $('.money[data-product-id]').each(function(){
            let currentPrice = $(this);
            
            let prevSibling = currentPrice.prev('.money-details');
            if (!prevSibling || prevSibling.length == 0) {
                return true;
            }
  
            let crossedOutPrice = prevSibling.find('.bold-pre-compare-price');
            if (!crossedOutPrice || crossedOutPrice.length == 0) {
                return true;
            }
          
            // if we reach this point, that means we found crossed-out price => show badge
            currentPrice.attr('data-pro-badge', '1');
        });
        clearInterval(appendProBadge);
    }
}, 100);


